// extracted by mini-css-extract-plugin
module.exports =  {"root":"sacfLLTSOK5m966E9hUE","left":"GYnBEsRdmJOpY5jjXXBE","right":"ehF5y24UicvGyrNuS5zA"};